import { useIntl } from 'react-intl';

export const getMonths = () => {
	const intl = useIntl();

	return [
		intl.formatMessage({ id: 'global.january' }),
		intl.formatMessage({ id: 'global.february' }),
		intl.formatMessage({ id: 'global.march' }),
		intl.formatMessage({ id: 'global.april' }),
		intl.formatMessage({ id: 'global.may' }),
		intl.formatMessage({ id: 'global.june' }),
		intl.formatMessage({ id: 'global.july' }),
		intl.formatMessage({ id: 'global.august' }),
		intl.formatMessage({ id: 'global.september' }),
		intl.formatMessage({ id: 'global.october' }),
		intl.formatMessage({ id: 'global.november' }),
		intl.formatMessage({ id: 'global.december' })
	];
};

export const getWeeksShort = () => {
	const intl = useIntl();

	return [
		intl.formatMessage({ id: 'global.sunday' }),
		intl.formatMessage({ id: 'global.monday' }),
		intl.formatMessage({ id: 'global.tuesday' }),
		intl.formatMessage({ id: 'global.wednesday' }),
		intl.formatMessage({ id: 'global.thursday' }),
		intl.formatMessage({ id: 'global.friday' }),
		intl.formatMessage({ id: 'global.saturday' })
	];
};
